import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    type: 'settings',
    list: [],
    general: {
        catalog: false,
        demographicBreakdown: false,
        frequency: false,
        quantile: false,
        surfintensity: false,
        accuracy: false,
        bootstrapPush: false,
        xdevice: false,
        firstPartyCookie: false,
        providerFirstIdActivated: false,
    },
    sociodemo: {
        demographic: false,
        behavioral: false,
        geography: false,
        technology: false
    },
    dataMining: {
        datamining: false,
        encryption: false,
        fullmode: false,
        secondparty: false,
        thirdparty: false,
        altid: false,
        sshKey: ''
    },
    extraTaxo: {
        isLoading: false,
        activeTaxo: null,
        list: {}
    },
    sharing: {
        taxonomies: [],
        audiences: [],
        activeSharing: [],
        sharedTaxonomies: {}
    },
    businessApps: {
        list: [],
        productAccountList: [],
        selectedBusinessApp: null
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
